<template>
	<div class="w-100 facility-home h-100 p-sm-3 p-2-5 d-flex d-sm-block align-items-center">
    <div class="mb-sm-2 icon">
      <div v-if="svgTag" v-html="svgTag"></div>
      <img v-else-if="$isNotEmptyV2(data.image_url)" :src="data.image_url" width="32"  />
      <i v-else class="text-semi-dark text-24" :class="iconName"></i>
    </div>
    <p class="mb-0 text d-inline-block align-middle">{{data.name}}</p>
	</div>
</template>
<script>
	export default{
		props: ['data'],
    computed:{
      iconName(){
        const splittedIcon = this.data.icon.split("-");
        return splittedIcon[0] !== 'iconsmind' ? this.data.icon : splittedIcon.map((icon, index) => index > 0 ? this.$capitalize(icon) : icon).join("-");
      },
      svgTag(){
        return this.data.svg_tag ? this.data.svg_tag : null
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/Facility.vue